module.exports = __webpack_public_path__ + "static/media/axolotyl-2.5412316e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/axolotyl-2.jpg
// module id = 241
// module chunks = 1